module.exports = __webpack_public_path__ + "static/media/icn-italic.37193645.svg";